// extracted by mini-css-extract-plugin
module.exports = {"tableHeader":"myTeam_tableHeader__1ygUK","boldText":"myTeam_boldText__ybDbs"};